import React, { Suspense, lazy, useEffect, useRef } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Dashboard from "./Dashboard";
import Reports from "./Reports";
import store from "../../store/store";
import { LayoutSplashScreen } from "../../../_metronic";
import SalesPage from "./sales/salesModule";
import CRMPage from "./crm/crmModule";
import FinancePage from "./finance/financeModule";
import Menu from "./menu";
import CommonPage from "./common/commonModule";
import { Toast } from "primereact/toast";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import ProductionPage from "./production/ProductionModule";
const InventoryPage = lazy(() => import("./inventory/inventoryModule"));
const UsersPage = lazy(() => import("./users/usersModule"));
const SetupPage = lazy(() => import("./setup/setupModule"));

export default function HomePage() {
  const location = useLocation();
  const { auth } = store.getState();
  const userID = auth.user.userID;
  const toast = useRef(null);
  const { socket } = useGlobalData();
  useEffect(() => {
    socket.on(`push-notifications:${userID}`, (message) => {
      toast.current.show({
        severity: "success",
        summary: "New Notification",
        detail: message,
        life: 5000,
      });
    });
    return () => {
      socket.off(`push-notifications:${userID}`);
    };
  }, [userID]); // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Toast ref={toast} />
      <Switch>
        {
          /* Redirect from root URL to /menu. */
          <Redirect exact from="/" to="/menu" />
        }
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/reports" component={Reports} />
        <Route path="/menu" component={Menu} />
        <Route path="/inventory" component={InventoryPage} />
        <Route path="/production" component={ProductionPage} />
        <Route path="/sales" component={SalesPage} />
        <Route path="/crm" component={CRMPage} />
        <Route path="/finance" component={FinancePage} />
        <Route path="/users" component={UsersPage} />
        <Route path="/setup" component={SetupPage} />
        <Route path="/common" component={CommonPage} />
        {location.pathname === "/auth/login" ? (
          <Redirect to="/menu" />
        ) : (
          <Redirect to="/error/error-invifo" />
        )}
      </Switch>
    </Suspense>
  );
}
